import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  Link,
  Badge,
  Button,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";
import { blue, red, green, yellow } from "@mui/material/colors";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
const notifications = [
  {
    id: 1,
    type: "all",
    title: "GRN Approval Pending",
    description: "GRN #12345 requires your approval. Click to review.",
    time: "2 min ago",
    icon: <AssignmentTurnedInIcon sx={{ color: yellow[700] }} />,
    avatarColor: yellow[100],
    badge: "New",
    badgeColor: blue[100],
    badgeTextColor: blue[700],
    actions: ["Approve", "Reject", "View"],
  },
  {
    id: 2,
    type: "all",
    title: "Return Approved",
    description: "Return #12345 – Your return has been approved.",
    time: "2 min ago",
    icon: <CheckCircleIcon sx={{ color: green[500] }} />,
    avatarColor: green[100],
    actions: ["View"],
  },
  {
    id: 3,
    type: "all",
    title: "Last hours of -50% Premium",
    description:
      "Say goodbye to design hassles and hello to effortless creativity with Freepik Premium. Get projects done quick and slick, no sweat, with ac...",
    time: "2 min ago",
    icon: <MailIcon sx={{ color: blue[500] }} />,
    avatarColor: blue[100],
    actions: ["View"],
  },
  {
    id: 4,
    type: "focused",
    title: "GRN Approval Pending",
    description: "GRN #12345 requires your approval. Click to review.",
    time: "2 min ago",
    icon: <AssignmentTurnedInIcon sx={{ color: yellow[700] }} />,
    avatarColor: yellow[100],
    badge: "New",
    badgeColor: blue[100],
    badgeTextColor: blue[700],
    actions: ["Approve", "Reject", "View"],
  },
  {
    id: 5,
    type: "other",
    title: "Last hours of -50% Premium",
    description:
      "Say goodbye to design hassles and hello to effortless creativity with Freepik Premium. Get projects done quick and slick, no sweat, with ac...",
    time: "2 min ago",
    icon: <MailIcon sx={{ color: blue[500] }} />,
    avatarColor: blue[100],
    actions: ["View"],
  },
  {
    id: 6,
    type: "all",
    title: "GRN Approval Pending",
    description: "GRN #12345 requires your approval. Click to review.",
    time: "2 min ago",
    icon: <AssignmentTurnedInIcon sx={{ color: yellow[700] }} />,
    avatarColor: yellow[100],
    badge: "New",
    badgeColor: blue[100],
    badgeTextColor: blue[700],
    actions: ["Approve", "Reject", "View"],
  },
];

function Notification() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const filteredNotifications = notifications.filter((notification) => {
    if (tabIndex === 0) return notification.type === "all";
    if (tabIndex === 1) return notification.type === "focused";
    if (tabIndex === 2) return notification.type === "other";
    return false;
  });

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        boxShadow: 3,
        borderRadius: 2,
        width: 420,
        height: "80vh",
        mx: "auto",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        // overflow: "hidden",

        // p: 2,
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1,
          borderBottom: 1,
          // borderColor: "divider",
          borderColor: theme.palette.greyscale.divider_1,

          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle_m">Notifications</Typography>
        <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>
      </Box>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        sx={{
          borderBottom: 1,
          borderColor: theme.palette.greyscale.divider_1,
          
        }}
      >
        <Tab
          label={
            <Badge badgeContent={6} color="secondary">
              All
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={4} color="primary">
              Focused
            </Badge>
          }
        />
        <Tab
          label={
            <Badge badgeContent={2} color="primary">
              Other
            </Badge>
          }
        />
      </Tabs>
      <Box
        sx={{
          px: 0,
          py: 1,
          scrollbarWidth: "none", // Hide scrollbar in Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers
          },
          overflowY: "auto",
          flexGrow: 1,
          height: "calc(100vh - 200px)",
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.default,
            width: "100%",
            px: 1,
          }}
        >
          <Typography variant="button_xs" color="textSecondary">
            Today
          </Typography>
        </Box>

        <Box px={2}>
          {filteredNotifications.map((notification) => (
            <React.Fragment key={notification.id}>
              <Box
                sx={{
                  display: "flex",
                  paddingLeft: 0,
                  width: "100%",
                  my: 1,
                  gap: 2,
                }}
              >
                <Box py={1}>
                  <Avatar sx={{ bgcolor: notification.avatarColor }}>
                    {notification.icon}
                  </Avatar>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      pr: 1,
                    }}
                  >
                    <Typography variant="subtitle_s">
                      <strong>{notification.title}</strong>
                      {notification.badge && (
                        <Badge
                          badgeContent={notification.badge}
                          sx={{
                            bgcolor: notification.badgeColor,
                            color: notification.badgeTextColor,
                            borderRadius: "12px",
                            px: 1,
                            ml: 1,
                          }}
                        />
                      )}
                    </Typography>
                    <IconButton
                      edge="end"
                      sx={{
                        // border: `1px solid ${theme.palette.system.error}`,
                        height: 24,
                        width: 24,
                        borderRadius: 1,
                      }}
                    >
                      <DisabledByDefaultOutlinedIcon
                        sx={{ color: theme.palette.system.error }}
                      />
                    </IconButton>
                  </Box>

                  <Typography variant="body_xs" color="textSecondary">
                    {notification.description}
                  </Typography>
                  <Typography
                    variant="body_xxs"
                    color="textSecondary"
                    display="block"
                    // mt={1}
                  >
                    {notification.time}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 1,
                      width: "100%",
                    }}
                  >
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {notification.actions
                        .filter(
                          (action) =>
                            action === "Approve" || action === "Reject"
                        )
                        .map((action, index) => (
                          <Button
                            key={index}
                            variant={
                              action === "Approve" ? "contained" : "outlined"
                            }
                            color="primary"
                            size="small"
                            sx={styles.btn_secondary}
                          >
                            {action}
                          </Button>
                        ))}
                    </Box>
                    {notification.actions.includes("View") && (
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        sx={styles.btn_secondary}
                      >
                        View
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
              <Divider />
            </React.Fragment>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          p: 2,
          borderTop: 1,
          borderColor: "divider",
          textAlign: "center",
        }}
      >
        <Button variant="text" sx={styles.btn_text}>
          {" "}
          View All
        </Button>
        {/* <Link href="#" underline="none" color="primary" variant="body2">
          View All
        </Link> */}
      </Box>
    </Box>
  );
}

export default Notification;
